import { Tooltip } from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => {
    return {
        itemInfoContainer: {
            display: 'flex',
            columnGap: '12px',
            minHeight: 'auto',
            height: 'auto',
            alignItems: 'center',
            fontSize: '14px',
            fontWeight: 600,
            lineHeight: '24px',
            padding: '8px 24px',
            maxWidth: '500px',
        },
        labelInfo: {
            width: '110px',
            textAlign: 'left',
        },
        contentInfo: {
            textAlign: 'left',
            maxWidth: '330px',
            '&.hasTooltip': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            },
            '& svg': {
                fill: `${theme.palette.backgroundRaisehand} !important`,
                '& path': {
                    fill: `${theme.palette.backgroundRaisehand} !important`,
                }
            },
            '& span': {
                color: theme.palette.backgroundRaisehand
            }
        }
    };
});
const ItemInfoRoom = ({ label, content, contentText = '' }) => {
    const { classes } = useStyles();
    const styles = label === '' ? { height: 'auto' } : {};
    const children = contentText ?
        (React.createElement(Tooltip, { title: contentText },
            React.createElement("div", { className: clsx(classes.contentInfo, 'hasTooltip') }, content))) :
        (React.createElement("div", { className: clsx(classes.contentInfo) }, content));
    return (React.createElement("div", { className: clsx(classes.itemInfoContainer), style: styles },
        React.createElement("div", { className: clsx(classes.labelInfo) }, label),
        children));
};
export default ItemInfoRoom;
